@if (!isHidden) {
<app-form-field label='Entités' required [control]="formControl">
  <app-multiselector [ngClass]="{'is-hidden': isHidden}" [items]='entitesVisibles' valueIdProperty='id'
    valueCaptionProperty='libelle' [formControl]='formControl' [proposedValuesFilter]='proposedValuesFilter'>
  </app-multiselector>
</app-form-field>
}
